import { useEffect } from "react";

function NotFound() {
    useEffect(() => {

    const meta = document.createElement('meta');
        meta.name = "robots";
        meta.content = "noindex";
        document.head.appendChild(meta);

        // Cleanup: remove the tag when the user navigates away
        return () => {
        document.head.removeChild(meta);
        };
    }, []);

    return (
        <section id="NotFound">
            <div id="Intro">
                <h1>404 - Page not found</h1>
            </div>
            <p>
                The page you requested is not available at this time. It may become available at a future 
                date but for now please select from the top level navigation a valide page.
            </p>
        </section>
    )
}

export default NotFound;